import script from "./EnvStepForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvStepForm.vue?vue&type=script&setup=true&lang=js"

import "./EnvStepForm.vue?vue&type=style&index=0&id=438875de&lang=css"

const __exports__ = script;

export default __exports__